import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ActiveInactiveFor, CustomFieldDisplay, GeneralConfigType, KeyValues10, KeyValues5, KeyValueSet, LocalService, Status } from 'src/service/local.service';
import { ProductManagementService } from '../../../service/product-management.service';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';

@Component({
  selector: 'app-custom-fields-config',
  templateUrl: './custom-fields-config.component.html',
  styleUrl: './custom-fields-config.component.scss'
})
export class CustomFieldsConfigComponent {
  @ViewChild('content_custom_fields_config')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  htmlId: string = ''; elementIds: any;
  @Input() countryCode: string = ''; @Input() businessId: string = '';
  items: KeyValues10[] = []; isShowDeleted = false;

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private productManagementService: ProductManagementService, private configurationManagementService: ConfigurationManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      title: 'title_' + this.htmlId,
      code: 'code_' + this.htmlId,
      btn_refresh: 'btn_refresh_' + this.htmlId,
      btn_save: 'btn_save_' + this.htmlId,
      btn_delete: 'btn_delete_' + this.htmlId,
      btn_arrow_more: 'btn_arrow_more_' + this.htmlId,
    };
  }

  ngOnInit(): void {
    this.onInitiate();
  }

  onInitiate() {
    this.onSetDisplayCustomFields();
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
    this.productManagementService.getCustomFields(this.businessId, !this.isShowDeleted).subscribe(result => {
      this.items = result;

      if (!this.isShowDeleted) {
        this.items.unshift({
          key: '-',
          v1: this.businessId,
          v2: '',
          v3: 'CF' + (this.items.length + 1),
          v4: '1'
        } as KeyValues10);
      }

      this.onSetDisplayForItems();
    });
  }


  displayCustomFields: KeyValueSet[] = []; selectedPurchaseEntryType: string = '1';
  displayCustomFieldsItems: KeyValueSet[] = [];

  onSetDisplayCustomFields() {
    this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.CustomFieldDisplay, true, false).subscribe(result => {
      this.displayCustomFields = result;
      this.onSetDisplayForItems();
    });
  }

  onAction(index: number, key1?: string, key2?: string) {
    switch (index) {
      case 1: {
        const item = this.items.find(x => x.key == key1);
        if (item) {
          this.productManagementService.saveCustomField(item).subscribe(result => {
            this.localService.showInformationByStatus(result.status);
            if (result.status == Status.Success) {
              this.onLoad();
            }
          });
        }
      } break;
      case 2: {
        this.productManagementService.activeInactiveStatus(key1, ActiveInactiveFor.CustomField).subscribe(result => {
          this.localService.showInformationByStatus(result.status);
          if (result.status == Status.Success) {
            this.onLoad();
          }
        });
      } break;
      case 3: {
        let activeInactiveFor = ActiveInactiveFor.None;
        switch (parseInt(key1)) {
          case CustomFieldDisplay.ProductsGrid: {
            activeInactiveFor = ActiveInactiveFor.CustomField_IsProductsGrid;
          } break;
          case CustomFieldDisplay.ProductSearch: {
            activeInactiveFor = ActiveInactiveFor.CustomField_IsProductSearch;
          } break;
          case CustomFieldDisplay.ProductNameInReceipt: {
            activeInactiveFor = ActiveInactiveFor.CustomField_IsProductNameInReceipt;
          } break;
        }

        if (activeInactiveFor != ActiveInactiveFor.None) {
          this.productManagementService.activeInactiveStatus(key2, activeInactiveFor).subscribe(result => {
            this.localService.showInformationByStatus(result.status);
          });
        }
      } break;
    }
  }

  onSetDisplayForItems() {
    this.displayCustomFieldsItems = [];
    if (this.items.length > 0 && this.displayCustomFields.length > 0) {
      this.items.forEach(item => {
        if (item.key && item.key.length > 5) {
          this.displayCustomFields.forEach(displayCustomField => {
            let itemToAdd = {
              isSelected: false,
              key: displayCustomField.key,
              s_value: item.key,
              value: displayCustomField.value
            } as KeyValueSet;

            switch (parseInt(displayCustomField.key)) {
              case CustomFieldDisplay.ProductsGrid: {
                itemToAdd.isSelected = item.v5 == '1';
              } break;
              case CustomFieldDisplay.ProductSearch: {
                itemToAdd.isSelected = item.v6 == '1';
              } break;
              case CustomFieldDisplay.ProductNameInReceipt: {
                itemToAdd.isSelected = item.v7 == '1';
              } break;
            }

            this.displayCustomFieldsItems.push(itemToAdd);
          });
        }
      });
    }
  }

  onGetDisplayForItems(key: string): KeyValueSet[] {
    return this.displayCustomFieldsItems.filter(x => x.s_value == key);
  }
}
